<div class="tabs">
    @for (tab of tabs(); track tab.id) {
        <div class="tab" [class.tab--active]="tab.id === currentTab()" (click)="onTabClick(tab.id)">
            <svg class="tab__icon" width="14" height="14">
                <use [attr.xlink:href]="'assets/icons/icons-sprite.svg#' + tab.iconKey"></use>
            </svg>
            <span class="tab__label">{{ tab.label }}</span>
        </div>
    }
</div>
